/* =====================================================================
   UmbraShow — interactions + video experience
   Nav · reveal · smooth scroll · counters · testimonial slider · forms
   Reusable accessible video modal · gallery lightbox · carousel

   NOTE: The video cards (hero card, latest thumbnail, featured grid,
   carousel items) are now SERVER-RENDERED by the Umbraco Razor views.
   Each play trigger carries its own data attributes:
     data-vopen  data-yt="<id>"  data-title  data-cat  data-sub
   so the modal plays the correct video without any client-side data array.
   ===================================================================== */

$(function () {

  /* ---------- Navbar scroll state ---------- */
  var $nav = $('#nav');
  if ($nav.length) {
    var onScroll = function () { $nav.toggleClass('is-scrolled', $(window).scrollTop() > 30); };
    $(window).on('scroll', onScroll);
    onScroll();
  }

  /* ---------- Mobile nav drawer: see js/nav.js ---------- */

  /* ---------- Smooth anchor scroll ---------- */
  $('a[href^="#"]').on('click', function (e) {
    var t = $(this).attr('href');
    if (!t || t.length < 2) return;
    var $tgt = $(t);
    if (!$tgt.length) return;
    e.preventDefault();
    $('html, body').animate({ scrollTop: $tgt.offset().top - 64 }, 680, 'swing');
  });

  /* ---------- Carousel navigation (operates on whatever cards exist) ---------- */
  function initCarousel() {
    var track = document.getElementById('usCarouselTrack');
    var prev = document.getElementById('usCarPrev');
    var next = document.getElementById('usCarNext');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.querySelector('.us-vcard');
      if (!card) return 320;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 22) || 22;
      return card.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return Math.max(0, track.scrollWidth - track.parentElement.clientWidth); }
    var pos = 0;
    function apply() {
      pos = Math.max(0, Math.min(pos, maxScroll()));
      track.style.transform = 'translateX(' + (-pos) + 'px)';
      prev.disabled = pos <= 1;
      next.disabled = pos >= maxScroll() - 1;
    }
    function page(dir) {
      var perView = Math.max(1, Math.round(track.parentElement.clientWidth / step()));
      pos += dir * step() * Math.max(1, perView - 0);
      apply();
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    window.addEventListener('resize', function () { pos = 0; apply(); });

    /* Touch / drag swipe */
    var startX = 0, startPos = 0, dragging = false;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; startPos = pos; dragging = true; track.style.transition = 'none'; }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      pos = startPos - (e.touches[0].clientX - startX);
      track.style.transform = 'translateX(' + (-Math.max(0, Math.min(pos, maxScroll()))) + 'px)';
    }, { passive: true });
    track.addEventListener('touchend', function () { dragging = false; track.style.transition = ''; apply(); });

    apply();
    setTimeout(apply, 300);
  }
  initCarousel();

  /* =================================================================
     VIDEO MODAL — reusable, accessible, lazy iframe.
     The clicked trigger supplies data-yt / data-title / data-cat / data-sub,
     so each podcast opens its OWN video (no shared/static data array).
     ================================================================= */
  var modal = document.getElementById('usVideoModal');
  if (modal) {
    var frame = document.getElementById('usModalFrame');
    var mTitle = document.getElementById('usModalTitle');
    var mSub = document.getElementById('usModalSub');
    var mCat = document.getElementById('usModalCat');
    var mClose = document.getElementById('usModalClose');
    var lastFocus = null;

    function openVideo(trigger) {
      if (!trigger) return;
      var yt = trigger.getAttribute('data-yt');
      if (!yt) return;
      var title = trigger.getAttribute('data-title') || 'UmbraShow Discussion';
      var cat = trigger.getAttribute('data-cat') || '';
      var sub = trigger.getAttribute('data-sub') || '';

      lastFocus = document.activeElement;
      mTitle.textContent = title;
      mSub.textContent = sub;
      mCat.textContent = cat;
      mCat.style.display = cat ? '' : 'none';

      // lazy-create the iframe only now
      frame.innerHTML = '<span class="us-modal__loading">Loading…</span>';
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0&modestbranding=1&playsinline=1');
      iframe.setAttribute('title', title);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('allowfullscreen', '');
      iframe.addEventListener('load', function () { var l = frame.querySelector('.us-modal__loading'); if (l) l.remove(); });
      frame.appendChild(iframe);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('us-modal-open');
      setTimeout(function () { mClose.focus(); }, 60);
    }
    function closeVideo() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('us-modal-open');
      // destroy iframe to stop playback
      setTimeout(function () { frame.innerHTML = '<span class="us-modal__loading">Loading…</span>'; }, 350);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Open triggers (event delegation): any element carrying data-vopen
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-vopen]');
      if (!t) return;
      e.preventDefault();
      openVideo(t);
    });

    mClose.addEventListener('click', closeVideo);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeVideo(); });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeVideo(); return; }
      if (e.key === 'Tab') {
        // focus trap — only close + iframe are focusable; keep focus inside
        var focusables = modal.querySelectorAll('button, iframe, a[href]');
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* =================================================================
     GALLERY LIGHTBOX — zoom & view community photos
     ================================================================= */
  (function () {
    var glb = document.getElementById('usGalleryLightbox');
    if (!glb) return;
    var photos = Array.prototype.slice.call(document.querySelectorAll('.us-gphoto'));
    if (!photos.length) return;
    var imgEl = document.getElementById('usGlbImg');
    var capEl = document.getElementById('usGlbCap');
    var btnClose = document.getElementById('usGlbClose');
    var btnPrev = document.getElementById('usGlbPrev');
    var btnNext = document.getElementById('usGlbNext');
    var cur = 0, lastFocus = null;

    function bigSrc(src) {
      // Prefer a full-size crop when the src carries a width querystring; otherwise use as-is.
      return src.replace(/([?&]width=)\d+/, '$1' + 1600).replace(/([?&]w=)\d+/, '$1' + 1600);
    }
    function dataFor(i) {
      var fig = photos[i];
      var img = fig.querySelector('img');
      var cap = fig.querySelector('figcaption');
      return { src: bigSrc(img.getAttribute('src')), alt: img.getAttribute('alt') || '', cap: cap ? cap.textContent : '' };
    }
    function show(i) {
      cur = (i + photos.length) % photos.length;
      var d = dataFor(cur);
      imgEl.src = d.src; imgEl.alt = d.alt; capEl.textContent = d.cap;
    }
    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      glb.classList.add('is-open');
      glb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('us-modal-open');
      setTimeout(function () { btnClose.focus(); }, 60);
    }
    function close() {
      glb.classList.remove('is-open');
      glb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('us-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    photos.forEach(function (fig, i) {
      fig.addEventListener('click', function () { open(i); });
      fig.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); }
      });
    });
    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { show(cur - 1); });
    btnNext.addEventListener('click', function () { show(cur + 1); });
    glb.addEventListener('click', function (e) { if (e.target === glb || e.target.classList.contains('us-glb__fig')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!glb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(cur - 1);
      else if (e.key === 'ArrowRight') show(cur + 1);
    });
  })();

  /* ---------- Scroll reveal (with safety fallback) ---------- */
  function revealAll() { document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    // Fallback: if anything is still hidden after a moment, reveal it so content is never stuck.
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) el.classList.add('is-visible');
      });
    }, 1400);
  } else {
    revealAll();
  }

  /* ---------- Animated counters (per stats section, on enter) ---------- */
  function animateCounter($el, target, suffix, dur) {
    dur = dur || 1800;
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      $el.text(Math.floor(eased * target).toLocaleString('en-IN') + suffix);
      if (t < 1) requestAnimationFrame(tick);
      else $el.text(target.toLocaleString('en-IN') + suffix);
    }
    requestAnimationFrame(tick);
  }
  function runCountersIn(section) {
    if (section.__ran) return;
    section.__ran = true;
    $(section).find('strong[data-count]').each(function () {
      var $s = $(this);
      animateCounter($s, parseInt($s.attr('data-count'), 10) || 0, $s.attr('data-suffix') || '');
    });
  }
  var $statSections = $('.us-stats');
  if ($statSections.length && 'IntersectionObserver' in window) {
    var statObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { runCountersIn(e.target); statObs.unobserve(e.target); } });
    }, { threshold: 0.35 });
    $statSections.each(function () { statObs.observe(this); });
  } else {
    $statSections.each(function () { runCountersIn(this); });
  }

  /* ---------- FAQ — close others on open ---------- */
  $('.faq-item').on('toggle', function () {
    if (this.open) $('.faq-item').not(this).each(function () { this.open = false; });
  });

  /* ---------- Testimonial slider (auto-sliding) ---------- */
  var $ttrack = $('#testiTrack');
  var $cards = $ttrack.children('.us-tcard');
  var $dotsWrap = $('#testiDots');
  if ($ttrack.length && $cards.length) {
    var n = $cards.length, cur = 0, timer = null;
    for (var i = 0; i < n; i++) {
      $dotsWrap.append('<button type="button" role="tab" aria-label="Go to testimonial ' + (i + 1) + '"></button>');
    }
    var $dots = $dotsWrap.children('button');
    function go(idx) {
      cur = (idx + n) % n;
      $ttrack.css('transform', 'translateX(' + (-cur * 100) + '%)');
      $dots.removeClass('is-active').attr('aria-selected', 'false').eq(cur).addClass('is-active').attr('aria-selected', 'true');
    }
    function nextSlide() { go(cur + 1); }
    function start() { stop(); timer = setInterval(nextSlide, 5500); }
    function stop() { if (timer) clearInterval(timer); }
    $dots.on('click', function () { go($dots.index(this)); start(); });
    $ttrack.parent().on('mouseenter', stop).on('mouseleave', start);
    go(0); start();
  }

  /* ---------- Form validation + feedback ---------- */
  function flashSent($form, $btn, label) {
    var orig = $btn.html();
    $btn.html(label);
    setTimeout(function () { $btn.html(orig); $form[0].reset(); }, 2600);
  }
  function validate($form) {
    var ok = true;
    $form.find('input[required], textarea[required]').each(function () {
      var v = $.trim(this.value);
      var bad = !v || (this.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v));
      $(this).closest('.field').toggleClass('field--error', bad);
      if (bad) ok = false;
    });
    return ok;
  }
  // NOTE: #contactForm is handled by the real AJAX submit in script-v4.js (hides the form and
  // shows the Thank You block). Don't bind it here or the placeholder would double-fire and reset it.
  $('#suggestForm').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
    if (!validate($form)) { $form.find('.field--error input, .field--error textarea').first().focus(); return; }
    var $btn = $form.find('button[type="submit"]');
    flashSent($form, $btn, 'Submitted ✓ — धन्यवाद');
  });
  $(document).on('input', '.field input, .field textarea', function () {
    $(this).closest('.field').removeClass('field--error');
  });

  /* ---------- Footer newsletter ---------- */
  $('.footer__news').on('submit', function (e) {
    e.preventDefault();
    var $btn = $(this).find('button');
    var orig = $btn.text();
    $btn.text('Thanks ✓');
    $(this).find('input').val('');
    setTimeout(function () { $btn.text(orig); }, 2400);
  });

});
